import axios from "axios";
import React, { useContext } from "react";

// Create a context and hook that allows us to configure
// the axios client in one place, and have all of the context
// children just access that config without any extra work.
const AxiosClientContext = React.createContext();

export function useClient(configOverride) {
  const contextConfig = useContext(AxiosClientContext);

  const config = { ...contextConfig, ...configOverride };
  return axios.create({
    baseURL: process.env.REACT_APP_BOOKINGS_API_URL,
    headers: { Authorization: `Bearer ${config.token}` }
  });
}

export const APIConfig = AxiosClientContext.Provider;
